import React from "react";
import PropTypes from "prop-types";
import { usePremium } from "@/hooks";

const BASE = "inner-layout-header-new";

const variants = {
  review: {
    top: "review-plan-header",
    bottom: "signup-login-header-top",
  },
  threeComp: {
    top: "top-three-comp-header",
    bottom: "top-three-comp-header-inner",
  },
};

const TopHeader = ({
  variant,
  outerClassname = "",
  topClassName = "",
  bottomClassName = "",
  allowPremiumOverride = true,
  children,
  ...rest
}) => {
  const { shouldToggleColor } = usePremium();

  const outerCls = [
    BASE,
    outerClassname,
    allowPremiumOverride && shouldToggleColor
      ? "mobile-top-header-premium"
      : "",
  ]
    .filter(Boolean)
    .join(" ")
    .trim();

  if (!variant || !variants[variant]) {
    return (
      <div className={outerCls} {...rest}>
        {children}
      </div>
    );
  }

  const { top, bottom } = variants[variant];

  return (
    <div className={outerCls} {...rest}>
      <div className={`${top} ${topClassName}`.trim()}>
        <div className={`${bottom} ${bottomClassName}`.trim()}>{children}</div>
      </div>
    </div>
  );
};

TopHeader.propTypes = {
  variant: PropTypes.oneOf(Object.keys(variants)),
  outerClassname: PropTypes.string,
  topClassName: PropTypes.string,
  bottomClassName: PropTypes.string,
  children: PropTypes.node,
  allowPremiumOverride: PropTypes.bool,
};

TopHeader.defaultProps = {
  allowPremiumOverride: true,
};

export default TopHeader;
